<template>
  <div class="col-sm-12">

    <div class="card news">
      <div class="card-header" style="border:none">
        <div class="row align-items-center justify-content-between news-header">
          <div class="col-auto">
            <h1 class="card-title news-title" v-html="convertString(titulo)"></h1>
          </div>
          <div class="col-auto col-btn-group noPadding">
            <div class="button-group" style="position: relative;">
              <button class="button icon-button tooltip tooltip-left groupNews" data-tooltip="Refrescar" @click="reload">
                <font-awesome-icon icon="sync" />
              </button>
              <button class="button icon-button tooltip tooltip-left groupNews" data-tooltip="Descargar"
                @click="download">
                <font-awesome-icon icon="cloud-download-alt" />
              </button>
              <button class="button icon-button tooltip tooltip-left groupNews" data-tooltip="Eliminar" @click="borrar">
                <font-awesome-icon icon="trash-alt" />
              </button>
              <button class="button icon-button tooltip tooltip-left groupNews"
                :data-tooltip="esc ? 'Carrousel' : 'Escaleta'" @click="escaleta">
                <font-awesome-icon icon="list" />
              </button>

              <button class="button icon-button tooltip tooltip-left groupNews" :data-tooltip="tooltipHide" @click="hide">
                <font-awesome-icon :icon="iconHide" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- end div class="card-header"-->
      <div :class="classBody">
        <div class="col-sm-12 channelStyle">
          <div class="fueradeHorario" v-if="sinElementos">Aún existen notas de ese programa en esta fecha</div>
          <timeline v-if="items.length > 0 && esc" :items="items" :LastEvaluatedKey="LastEvaluatedKey" @loadMore="loadMore"
            @goToNoteTimeline="goToNote"></timeline>
          <slider-video-notes :fi="medio" :items="items" :keyNota="keyNota" :titulo="titulo" @goToNote="goToNote" @goToNotes="goToNotes" @loadMore="loadMore" @goToWss="goToWss"
            v-else></slider-video-notes>


        </div>

      </div>

      <!-- end row justify-content-center-->

    </div>

  </div>
</template>

<script>
import sliderVideoNotes from "@/components/sliderVideoNotes";

import timeline from "@/components/timeline";

import moment from "moment-timezone";
import { strings } from "@/services/strings.js";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faSync,
  faChevronDown,
  faChevronUp,
  faTrashAlt,
  faList,
  faCloudDownloadAlt
} from "@fortawesome/free-solid-svg-icons";
library.add(faSync);
library.add(faChevronDown);
library.add(faChevronUp);
library.add(faTrashAlt);
library.add(faList);
library.add(faCloudDownloadAlt);

export default {
  name: "notiNotas",
  props: ["item", "medio", "ndx", "fecha"],
  components: { sliderVideoNotes, timeline },
  mixins: [strings],
  data() {
    return {
      url: this.$store.getters.getMainUrl,
      providerID: this.$store.state.userInfo.net,
      items: [],
      titulo: "",
      query: {
        fi: {},
        ubicacion: "global",
        fecha: {
          fin: ""
        },
        hora: {
          ini: "00:00",
          fin: "23:59"
        },
        keywords: [],
        reload: true
      },
      LastEvaluatedKey: 0,
      total: 0,
      limit: 20,
      classBody: ["row", "justify-content-center"],
      tooltipHide: "Ocultar",
      iconHide: "chevron-up",
      sinElementos: false,
      esc: false,
      wssMore:false,
      dataTMp: null
    };
  },
  computed: {
    token() {
      return this.$store.getters.getToken;
    }
  },
  mounted() {
    //setInterval(this.reload(),300000);
  },
  watch: {
    fecha() {
      //console.log("cambió fecha en notiNotas:");
      // console.log(this.fecha);
      this.clear();
      this.getConfig();
    }
  },
  beforeMount() {
    this.getConfig();
  },
  methods: {
    getConfig() {
      this.titulo = this.item.nombre;
      this.keyNota = this.item.key;
      var arr = [];
      arr.push(this.item.key);
      switch (this.medio) {
        case "T":
          this.query.fi = { T: arr };
          break;
        case "R":
          this.query.fi = { R: arr };
          break;
        case "TW":
          this.query.fi = { TW: arr };
          break;
        case "FB":
          this.query.fi = { FB: arr };
          break;
        case "Y":
          this.query.fi = { Y: arr };
          break;
        case "PD":
          this.query.fi = { PD: arr };
          break;
        case "I":
          this.query.fi = { I: arr };
          break;
        case "TK":
          this.query.fi = { TK: arr };
          break;
      }
      this.query.limit = this.limit;
      //this.query.fecha.ini = this.fecha;
      this.query.fecha.fin = this.fecha;
      console.log(this.query);
      this.getItems();
    },
    getItems() {
      var self = this;
      this.query.LastEvaluatedKey = this.LastEvaluatedKey;
      axios
        .post(self.url + "queryElasticsearch", JSON.stringify(self.query))
        .then(response => {
          if (response.data.success) {
            var result = JSON.parse(response.data.data);

            if (result.total > 0) {
            } else {
              self.sinElementos = true;
              self.hide();
            }
            if (self.items.length > 0) {
              self.items = [].concat(self.items, result.result[self.medio]);
            } else {
              self.items = result.result[self.medio];
            }
            self.total = result.total;
            self.LastEvaluatedKey =
              self.limit + self.LastEvaluatedKey > self.total
                ? -1
                : self.limit + self.LastEvaluatedKey;
          }
        });
    },
    hide() {
      if (this.classBody.indexOf("hidden") == -1) {
        //ocultamos
        this.iconHide = "chevron-down";
        this.tooltipHide = "Mostrar";
        this.classBody.push("hidden");
      } else {
        //mostramos
        this.iconHide = "chevron-up";
        this.tooltipHide = "Ocultar";
        this.classBody.pop();
      }
    },
    goToNote(params) {
      this.$emit("goToNote", params);
    },
    goToNotes(params) {
      this.$emit("goToNotes", params);
    },
    goToWss(data){
      var self = this;
      self.items = [].concat(data,self.items)
    },
    reload() {
      this.items = [];
      this.LastEvaluatedKey = null;
      this.getItems();
    },
    loadMore() {
      if (this.LastEvaluatedKey) this.getItems();
    },
    download() {
      this.query.titulo = this.titulo;
      this.$emit('download', this.query);
    },
    success() {
      this.$emit("success", msg);
    },
    error(msg) {
      this.$emit("error", msg);
    },
    borrar() {
      this.$emit("borrar", this.ndx);
    },
    escaleta() {
      this.esc = !this.esc;
      // this.$emit("escaleta", { ndx: this.ndx, item: this.items[0], items:this.items,LastEvaluatedKey:this.LastEvaluatedKey });
    },
    clear() {
      this.items = [];
      this.LastEvaluatedKey = 0;
      this.total = 0;
    }
  }
};
</script>


<style scoped>
.fueradeHorario {
  color: #fff;
  text-align: center;
  width: 100%;
  padding: 10px 0px;
}

.hidden {
  display: none;
}

.groupNews {
  background: none !important;
  color: white !important;
}

.news-header {
  /*background: #00b99e;
  border-radius: 15px 15px 0 0;*/
  border-bottom: 1px solid #456871;
}

.news-title {
  color: white;
  margin-bottom: 5px;
}

.news {
  margin-bottom: 10px;
  background: none;
  padding: 0 30px 0 30px;
}

.icon-button {
  background: #062633;
  color: #00b99e;
}

.icon-button:hover {
  background: #00b99e;
  color: white;
}

.active {
  background-color: #00b99e;
  fill: white !important;
  color: white !important;
}

.active:hover {
  background-color: #062633;
  fill: #00b99e !important;
  color: #00b99e !important;
}
</style>
 